import AthubCloudApi from '@/api/athubCloud'
import PersonServer from '@/api/person/index'
import DateUtil from '@/util/common/date'
import KpiServer from '@/api/kpi/index'

export default {

    namespaced: true,

    state: {

        kpiInfo: {
            id: null,
            kpino: '',
            deptid: null,
            kpidate: null,
            owner: '',
            changeby: '',
            status: '',
        },

        kpiPersonList: [],

        kpiPageInfo: {},

    },

    getters: {

        kpiInfo(state) {
            return state.kpiInfo;
        },

        kpiPersonList(state) {
            return state.kpiPersonList;
        },

        kpiPageInfo(state) {
            return state.kpiPageInfo;
        },

    },

    mutations: {

        setKpiInfo(state, payload) {
            state.kpiInfo = payload;
        },

        setKpiPersonList(state, payload) {
            state.kpiPersonList = payload;
        },


        setKpiPageInfo(state, payload) {
            state.kpiPageInfo = payload;
        },
    },

    actions: {

        //获取选定月份内在职、包括1号之后离职的人员
        getKpiPersonList({commit}, payload) {
            let kpiPersonList = [];
            return new Promise((resolve, reject) => {
                PersonServer.personApi.fetchByRedis(payload).then((responseBody) => {
                    kpiPersonList = responseBody;
                    let date1 = DateUtil.stringToDate(payload.kpidate);
                    let currentMonth = date1.getFullYear() + '-' + (((date1.getMonth() + 1) + '').length == 1 ? ('0' + (date1.getMonth() + 1)) : date1.getMonth() + 1) + '-01';
                    let date2 = DateUtil.stringToDate(currentMonth, '-');
                    date2.setMonth(date2.getMonth() + 1);
                    let nextMonth = date2.Format('yyyy-MM-dd');

                    kpiPersonList = kpiPersonList.filter(item => {
                        return (item.status == '1' && item.validation == 'VALID' && item.hireDate < nextMonth)
                            || (item.status == '0' && item.terminationDate >= currentMonth && item.validation == 'VALID' && item.hireDate < nextMonth);
                    });
                    resolve(kpiPersonList);
                });
            }).catch(error => {
                console.log('获取KPI人员列表失败');
                reject(error);
            });
        },

        //获取前两个月到选定月份离职人员列表，用于过滤情况：某员工实际离职时间11月，但是没有及时录入，到12月5日后KPIJOB生成中有他，需要获取前两个月离职的人员，与KPIRESULT比对，删除多生成的已离职人员记录
        //月头存在，之后删除的用户，也需要删除
        getLeavePersonList({commit}, payload) {
            let leavePersonList = [];
            return new Promise((resolve, reject) => {
                PersonServer.personApi.fetchByRedis(payload).then((responseBody) => {
                    leavePersonList = responseBody;
                    let date1 = DateUtil.stringToDate(payload.kpidate);
                    let currentMonth = date1.getFullYear() + '-' + (((date1.getMonth() + 1) + '').length == 1 ? ('0' + (date1.getMonth() + 1)) : date1.getMonth() + 1) + '-01';
                    let date2 = DateUtil.stringToDate(currentMonth, '-');
                    date2.setMonth(date2.getMonth() - 2);
                    let monthBeforLast = date2.Format('yyyy-MM-dd');
                    leavePersonList = leavePersonList.filter(item => {
                        return ((item.status == '0' && (item.terminationDate >= monthBeforLast && item.terminationDate < currentMonth)) || item.validation == 'INVALID');
                    });
                    resolve(leavePersonList);
                });
            }).catch(error => {
                console.log('获取离职人员列表失败');
                reject(error);
            });
        },

        getKpiPageInfo({commit}, params) {
            KpiServer.kpi.page(params, {
                headers: {
                    orgId: localStorage.getItem("authorg"),
                    sites: localStorage.getItem("authsites"),
                }
            }).then((responseBody) => {
                let tableData = responseBody.data.data.pageData;
                let total = responseBody.data.data.total;
                commit("setKpiPageInfo", {
                    tableData: tableData,
                    total: total
                });
            });
        },

    },

}